// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chip-content[data-v-39a601f3]{display:flex;align-items:center}.text-container[data-v-39a601f3]{flex:1;margin-right:.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
